import React from "react";
import { useNavigate } from "react-router-dom";

interface OutlineButtonProps {
  text: string;
  link: string;
}

const OutlineButton = (props: OutlineButtonProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(props.link);
  };

  return (
    <button
      className="bg-transparent hover:bg-purple-200 py-5 px-16 hover:text-black text-black font-md border border-2 border-yellow-500 hover:border-yellow-500 rounded"
      onClick={handleClick}
    >
      {props.text}
    </button>
  );
};

export { OutlineButton };
